<template>
    <div class="query-result">
        <div class="result-title" style="margin-bottom:40px;">
            <span>查询结果</span>
        </div>
        <!-- 未补全个人信息情况下在查询页的提示 -->

        <a-alert v-if="userinfo && (!userinfo.cardNumber || !userinfo.userName)" message="请补全个人信息再进行查询" type="error" show-icon style="width:250px;margin:0 auto" />
        <div class="result-content">
            <div class="result-left">
                <p>
                    身份证号：
                    <span>{{ userinfo.cardNumber !== null ? userinfo.cardNumber : '' }}</span>
                </p>
                <p>
                    姓名：
                    <span>{{ userinfo.userName !== null ? userinfo.userName : '' }}</span>
                </p>
            </div>
            <div class="result-right">
                <a-table :data-source="examResultList" rowKey="id" :pagination="false">
                    <a-table-column key="id" title="序号" data-index="id" align="center" />
                    <a-table-column key="certificateTypeName" title="证书类型" data-index="certificateTypeName" align="center" />
                    <a-table-column key="subjectName" title="考试科目" data-index="subjectName" align="center" />
                    <!-- 将考试时间和证书过期时间格式化,只显示日期 -->
                    <a-table-column key="beginTime" title="考试时间" align="center">
                        <template v-slot="scope">
                            <span>
                                {{ $filters.timeToDate(scope.text.beginTime) }}
                            </span>
                        </template>
                    </a-table-column>
                    <a-table-column key="score" title="考试成绩" data-index="score" align="center" />
                    <a-table-column key="certificateNumber" title="证书编号" data-index="certificateNumber" align="center" />
                    <a-table-column key="endTime" title="证书过期时间" align="center">
                        <template v-slot="scope">
                            <span>
                                {{ $filters.timeToDate(scope.text.endTime) }}
                            </span>
                        </template>
                    </a-table-column>
                    <a-table-column key="statusName" title="证书状态" data-index="statusName" align="center">
                        <template v-slot="scope">
                            <a href="https://edu.uniontech.com/equis" v-if="scope.record.statusName == '过期'">过期</a>
                            <span v-if="scope.record.statusName == '通过'">通过</span>
                            <span v-if="scope.record.statusName == '未通过'">未通过</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="action" title="操作" align="center">
                        <template v-slot="scope">
                            <span>
                                <a href.prevent="" v-if="scope.text.status == 1" @click="downLoadCert(scope.text.certificateNumber)">下载证书</a>
                            </span>
                        </template>
                    </a-table-column>
                </a-table>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { searchExamResult, downLoadExamResult } from '@/request/certificate';
import router from '@/router';
const token = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : '';

export default {
    name: '',
    props: {},
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            examResultList: 'certificate/examResultList',
            certificateNumber: 'certificate/certificateNumber',
        }),
    },
    watch: {},
    methods: {
        ...mapActions({
            SearchExamResult: 'certificate/SearchExamResult',
        }),

        async downLoadCert(data) {
            const res = await downLoadExamResult(data, token);
            if (res) {
                console.log('下载', res);
            }
            const url = window.URL.createObjectURL(res.data);
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', `${data}.pdf`);
            document.body.appendChild(link);
            link.click();
        },
    },
    created() {},
    async mounted() {
        let token = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : '';
        let userinfo = localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : null;
        if (userinfo && userinfo.cardNumber) {
            this.SearchExamResult();
        }
    },
    beforeUnmount() {},
    components: {},
    filters: {},
};
</script>
<style lang="scss" scoped>
.result-title {
    font-size: 20px;
    font-weight: bold;
    color: #000;
    height: 54px;
    width: 100%;
    background: #fff;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.05);
    margin-bottom: 36px;
    text-align: center;
    line-height: 54px;
}
.result-content {
    padding: 50px 200px;
    display: flex;
    box-shadow: 0 4px 10px 2px rgba(0, 0, 0, 0.05);
    background-color: #fff;
    background-image: url('../../../assets/circle.svg');
    background-repeat: no-repeat;
    background-position: 100% 100%;
    .result-left {
        flex: 1;
        font-size: 15px;
        color: #333;
    }
    .result-right {
        flex: 4;
        min-width: 1000px;
    }
}
</style>
